<template>
	<div v-show="isShow">
		<div v-show="i.arr.length != 0" class="nf-main" v-for="(i, index) in columnList" :key="index">
			<div class="nf-main-title">
				<b>{{ i.column }}</b>
				<p @click="gocolumn(i.column)" style="cursor: pointer">更多></p>
			</div>
			<div class="nf-content">
				<div @click="reFreshUrl(i.arr[0].number)" class="nf-img" v-if="i.arr[0]">
					<router-link :to="{ path: '/index/article', query: { id: i.arr[0].number } }" style="text-decoration: none;color:black">
						<img v-lazy="i.arr[0].imgUrl1" alt />
						<div class="img-title">{{ i.arr[0].title }}</div>
					</router-link>
				</div>
				<div class="nf-wen">
					<div class="nf-wen-list" v-for="(item, index) in i.arr.slice(1)" :key="index">
						<div class="nf-wen-list-zi" @click="reFreshUrl(item.number)">
							<router-link :to="{ path: '/index/article', query: { id: item.number } }" style="text-decoration: none;color:black">{{
								item.title
							}}</router-link>
						</div>
						<div style="display:flex;justify-content: space-between;">
							<div class="imglist-editor">{{ item.editor }}</div>
							<div class="imglist-time">
								<i class="el-icon-time"></i>
								{{ handleDate(item.createTime) }}
							</div>
						</div>
						<hr color="#CFCFCF" size="1px" />
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			column: [],
			columnList: {},
			artNumber: "",
			show: "",
			bodyWidth: document.body.clientWidth, //当前窗口的宽度
			clientHeight: "",
			timer: false,
			num: 0,
		}
	},
	computed: {
		isShow() {
			return document.body.clientWidth <= 768
				? this.$store.state.columnTitle == "全部"
					? this.$route.path == "/index/article"
						? false
						: true
					: false
				: true
			// (this.$route.path == "/index/article" ? false : true) : true
		},
	},
	watch: {},
	methods: {
		showIcon() {
			if (this.num < 1) {
				if (!!document.documentElement.scrollTop && document.documentElement.scrollTop > 1450) {
					this.getColumnArc()
				} else {
					// console.log(document.documentElement.scrollTop)
				}
			}
		},
		//遍历栏目信息
		async getColumnArc() {
			this.num = this.num + 1
			if (this.num > 1) {
				return
			}
			const Res = await this.post("/website/getColumnArc", {
				city: this.$store.state.city,
				limit: 6,
			}).catch((err) => {
				console.log(err)
			})
			for (let i in Res.data) {
				if (i == "即时动态") {
					continue
				}
				this.column.push(i)
			}
			var arr = []
			for (let val of this.column) {
				arr.push({
					column: val,
					arr: Res.data[val],
				})
			}
			// console.log(arr)
			this.columnList = arr
			// console.log(this.columnList)
			// this.columnList = tempData
		},

		//跳转栏目
		gocolumn(e) {
			if (this.$route.path != "/index/whole") {
				this.$router.push("/index/whole")
			}
			this.$store.commit("setColumnTitle", e)
			window.scrollTo(0, 800)
		},
		reFreshUrl(e) {
			this.$store.commit("setartrcleNumber", e)
			// console.log(e)
		},
	},
	mounted() {
		if (this.num < 1) {
			window.addEventListener("scroll", this.showIcon)
		}
	},
}
</script>

<style lang="scss" scoped>
.nf-main {
	width: 100%;
	height: 500px;
	padding: 15px;
	margin: 0 0 60px 0;
	box-sizing: border-box;
	background-color: rgb(255, 255, 255);
	border: rgba(0, 0, 0, 0.12) solid 1px;
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
}
.nf-main-title {
	width: 100%;
	height: 50px;
	b {
		font-size: 30px;
	}
	p {
		float: right;
	}
}
.nf-content {
	display: flex;
}
.nf-img {
	width: 50%;
	height: 420px;
	padding: 0 10px 0 0;
	box-sizing: border-box;
	img {
		width: 100%;
		height: 100%;
	}
}
.img-title {
	position: relative;
	font-size: 25px;
	top: -49px;
	height: 45px;
	overflow: hidden;
	text-overflow: ellipsis;
	display: -webkit-box;
	-webkit-line-clamp: 1;
	-webkit-box-orient: vertical;
	background-color: rgba(0, 0, 0, 0.4);
	padding: 10px 0 20px 20px;
	box-sizing: border-box;
	color: white;
}
.nf-wen {
	display: block;
	width: 50%;
	margin: -25px 40px 0 40px;
	.nf-wen-list {
		margin: 20px 0 0 0;
		width: 100%;
		.nf-wen-list-zi {
			height: 50px;
			padding: 0 0 0 0;
			a {
				text-decoration: none;
				font-size: 20px;
				color: rgb(0, 0, 0);
			}
		}
	}
}
.imglist-editor {
	color: #618ebc;
	font-size: 14px;
}
.imglist-time {
	color: rgba(0, 0, 0, 0.5);
	font-size: 14px;
	margin: 0 10px 0 0;
}
@media (max-width: 768px) {
	.nf-main {
		height: 100%;
	}
	.nf-main-title {
		b {
			font-size: 20px;
		}
		p {
			float: right;
		}
	}
	.nf-content {
		display: block;
	}
	.nf-img {
		width: 100%;
		height: 200px;
		padding: 0;
	}
	.img-title {
		font-size: 16px;
		top: -27px;
		height: 23px;
		overflow: hidden;
		background-color: rgba(0, 0, 0, 0.4);
		padding: 0 0 0 20px;
		box-sizing: border-box;
		color: white;
	}
	.nf-wen {
		display: block;
		width: 100%;
		margin: 0px 0px 0 10px;
		p {
			margin: 0 0 10px 0;
		}
		.nf-wen-list {
			margin: 20px 0 0 0;
			width: 100%;
			.nf-wen-list-zi {
				height: 40px;
				margin: 0 0 5px 0;
				overflow: hidden;
				text-overflow: ellipsis;
				display: -webkit-box;
				-webkit-line-clamp: 2;
				-webkit-box-orient: vertical;
				a {
					text-decoration: none;
					font-size: 15px;
					color: black;
				}
			}
		}
		.imglist-editor {
			font-size: 10px;
		}
		.imglist-time {
			font-size: 10px;
		}
	}
}
</style>
